import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/AboutGuufs/page'));
const ServicesPage = lazy(() => import('../pages/OurServices/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const ConsultationPage = lazy(() => import('../pages/consultation/page'));
const BlogPage = lazy(() => import('../pages/GuufsStories/page'));
const BlogDetailPage = lazy(() => import('../pages/GuufsStories/details/page'));
const PrivacyPolicyPage = lazy(() => import('../pages/privacy/page'));
const TermsOfServicePage = lazy(() => import('../pages/terms/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));
const AdminLoginPage = lazy(() => import('../pages/admin/login/page'));
const AdminDashboardPage = lazy(() => import('../pages/admin/dashboard/page'));
const AdminConsultationsPage = lazy(() => import('../pages/admin/consultations/page'));
const AdminSubscribersPage = lazy(() => import('../pages/admin/subscribers/page'));
const AdminMessagesPage = lazy(() => import('../pages/admin/messages/page'));
const AdminBlogPage = lazy(() => import('../pages/admin/blog/page'));
const AdminBlogEditorPage = lazy(() => import('../pages/admin/blog/editor'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/AboutGuufs',
    element: <AboutPage />,
  },
  {
    path: '/OurServices',
    element: <ServicesPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/consultation',
    element: <ConsultationPage />,
  },
  {
    path: '/GuufsStories',
    element: <BlogPage />,
  },
  {
    path: '/GuufsStories/:slug',
    element: <BlogDetailPage />,
  },
  {
    path: '/privacy-policy',
    element: <PrivacyPolicyPage />,
  },
  {
    path: '/terms-of-service',
    element: <TermsOfServicePage />,
  },
  {
    path: '/admin/login',
    element: <AdminLoginPage />,
  },
  {
    path: '/admin/dashboard',
    element: <AdminDashboardPage />,
  },
  {
    path: '/admin/consultations',
    element: <AdminConsultationsPage />,
  },
  {
    path: '/admin/subscribers',
    element: <AdminSubscribersPage />,
  },
  {
    path: '/admin/messages',
    element: <AdminMessagesPage />,
  },
  {
    path: '/admin/blog',
    element: <AdminBlogPage />,
  },
  {
    path: '/admin/blog/new',
    element: <AdminBlogEditorPage />,
  },
  {
    path: '/admin/blog/edit/:id',
    element: <AdminBlogEditorPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
